export const PATH = {
  HOME: '/',
  TRAFFIC_VIOLATIONS_LOOKUP: '/tra-cuu-phat-nguoi',
  TRAFFIC_VIOLATIONS_RESULT: '/chi-tiet-phat-nguoi'
}
